// CreateUserModal.jsx
import React, { useState } from "react";
import { adminApi } from "./adminApi";
import "./CreateUserModal.css";

export default function CreateUserModal({ onClose, onCreated }) {
  const [companyName, setCompanyName] = useState("");
  const [expiryDays, setExpiryDays] = useState("7");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null); // holds { username, plaintextPassword } after creation
  const [copied, setCopied] = useState(false);

  // Strips anything that isn't a digit, so decimals, minus signs, "e", etc. can never
  // land in the field even if pasted in - only whole numbers are ever stored.
  function handleExpiryDaysChange(e) {
    const digitsOnly = e.target.value.replace(/[^0-9]/g, "");
    setExpiryDays(digitsOnly);
  }

  // Also block the keys that <input type="number"> would otherwise silently accept
  // (., -, e, E) right at the keystroke level, not just after the fact.
  function handleExpiryDaysKeyDown(e) {
    if (["-", "+", ".", "e", "E"].includes(e.key)) {
      e.preventDefault();
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const days = parseInt(expiryDays, 10);
    if (!days || days < 1) {
      setError("Enter a whole number of days (1 or more).");
      return;
    }

    setLoading(true);
    try {
      const created = await adminApi.createUser(companyName.trim(), days);
      setResult(created);
      onCreated(); // let parent refresh the table in the background
    } catch (err) {
      setError(err.message || "Could not create user.");
    } finally {
      setLoading(false);
    }
  }

  function copyCredentials() {
    const text = `Username: ${result.username}\nPassword: ${result.plaintextPassword}`;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="cum-overlay" onClick={onClose}>
      <div className="cum-card" onClick={(e) => e.stopPropagation()}>
        {!result ? (
          <>
            <h2 className="cum-title">Create Client Access</h2>
            <form onSubmit={handleSubmit}>
              <label className="cum-label">Company name</label>
              <input
                className="cum-input"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                placeholder="e.g. Vasuki Infra"
                required
              />

              <label className="cum-label">Access duration (days)</label>
              <input
                className="cum-input"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={expiryDays}
                onChange={handleExpiryDaysChange}
                onKeyDown={handleExpiryDaysKeyDown}
                placeholder="e.g. 7"
                required
              />

              {error && <div className="cum-error">{error}</div>}

              <div className="cum-actions">
                <button type="button" className="cum-btn-secondary" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="cum-btn-primary" disabled={loading}>
                  {loading ? "Creating…" : "Create"}
                </button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h2 className="cum-title">Access Created</h2>
            <p className="cum-warning">
              This password is shown only once. Copy it now and send it to the client — it can't
              be retrieved again after you close this window.
            </p>

            <div className="cum-credentials">
              <div className="cum-cred-row">
                <span className="cum-cred-label">Username</span>
                <span className="cum-cred-value">{result.username}</span>
              </div>
              <div className="cum-cred-row">
                <span className="cum-cred-label">Password</span>
                <span className="cum-cred-value">{result.plaintextPassword}</span>
              </div>
            </div>

            <div className="cum-actions">
              <button className="cum-btn-secondary" onClick={copyCredentials}>
                {copied ? "Copied ✓" : "Copy both"}
              </button>
              <button className="cum-btn-primary" onClick={onClose}>
                Done
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}